import Logger from 'alife-logger'
import store from '@/store'

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_ARMS_PID) {
  const __bl = Logger.singleton(
    {
      pid: process.env.VUE_APP_ARMS_PID, // 前端监控应用ID
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      sendResource: true,
      enableLinkTrace: true,
      behavior: true,
      useFmp: true,
      release: process.env.VUE_APP_ARMS_VERSION, // 版本号
      environment: process.env.VUE_APP_ARMS_PROD // 环境
    }
  )

  // 禁用API自动上报
  __bl.setConfig({
    disableHook: true
  })

  // 若页面加载初期暂时无法获取用户名，则可设置返回Null，但不要设置返回一个临时用户名。因为SDK发送日志时会再次调用setUsername方法获取用户名，如果之前设置了返回临时用户名，则会一直沿用最初设置的用户名，不再重新获取。
  __bl.setConfig({
    setUsername: function () {
      console.log(store.getters?.user)
      return store.getters?.user?.userName ?? null
    }
  })

  // 忽略指定URL/API/JS错误。符合规则的日志将被忽略且不会被上报，包含子配置项ignoreUrls、ignoreApis、ignoreErrors和ignoreResErrors。
  __bl.setConfig({
    ignore: {
      // 忽略某些URL
      ignoreUrls: [
        function (str:string) {
          return false // 上报
        }
      ],
      // 忽略某些API
      ignoreApis: [
        function (str:string) {
          return false // 上报
        }
      ],
      // 忽略某些JS错误
      ignoreErrors: [
        function (str:string) {
          // "Cannot read properties of undefined (reading 'data')",
          // "Cannot read properties of undefined (reading 'success')"
          // https://stackoverflow.com/questions/64238740/how-to-ignore-the-resizeobserver-loop-limit-exceeded-in-testcafe
          console.log('ams error', str)
          if (/[ResizeObserver\sloop] | [reading\s'data'] | [reading\s'success'] | [evaluating\s'e.data'] | [evaluating\s'e.success'] | [n is not defined] | [Network\sError]/.test(str)) return true
          return false // 上报
        }
      ],
      // 忽略指定的资源错误
      ignoreResErrors: [
        function (str:string) {
          return false // 上报
        }
      ]
    }
  })
  // 自定义字段
}
